import { createServerFn } from "@tanstack/react-start";
import { AanvraagSchema } from "./aanvraag-schema";
import { submitAanvraagServer } from "./leads.server";

export const submitAanvraag = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => AanvraagSchema.parse(input))
  .handler(({ data }) => submitAanvraagServer(data));
